<template>
  <!-- 발생한 경보만 배지로 보여준다 (경보 없는 항목은 그리지 않는다). vertical 이면 세로로 쌓는다 -->
  <div :class="{ 'd-flex flex-column align-items-end': vertical }">
    <CBadge v-for="it in activeItems" :key="it.code"
            v-b-tooltip.hover.html.v-danger="eventTip[it.code]"
            class="font-weight-bolder evt-badge"
            :class="{ 'font-lg': $store.state.largeFont, 'mb-1': vertical, 'mr-1': !vertical }"
            :color="badgeColor[it.code]">{{ it.label }}</CBadge>
  </div>
</template>

<style>
/* 경보뱃지 텍스트는 흰색으로 밝게 하고, 노랑(warning)·하늘색(info) 배경에서도 읽히도록
   옅은 그림자를 준다. 탱크 그림 위에 겹쳐 뜨므로 글자도 키운다 */
.evt-badge {
  color: #ffffff !important;
  text-shadow: 0 0 2px rgba(0, 0, 0, 0.6);
  font-size: 0.95rem;
  padding: 0.3em 0.5em;
}
/* CoreUI Pro 의 .font-lg { font-size: 1rem !important } 보다 우선해야 한다 */
.evt-badge.font-lg {
  font-size: 1.15rem !important;
}
.tooltip .tooltip-inner {
  text-align: left;
  max-width: 350px !important;
  width: 250px !important;
}
</style>

<script>
import { iosDtToLocal } from "@/common/utils";

export default {
  name: 'WidgetEvents',
  props: {
    // 배지를 세로로 쌓아 표시 (탱크 카드의 우측 오버레이용)
    vertical: { type: Boolean, default: false },
  },
  data () {
    return {
      // 표시 순서. 1-넘침, 6-넘침2, 2-부족, 7-부족2, 4-수분, 5-누유, 3-화재(고온), 9-점검
      items: [
        {code:'1', label:'넘침'}, {code:'6', label:'넘침*'},
        {code:'2', label:'부족'}, {code:'7', label:'부족*'},
        {code:'4', label:'수분'}, {code:'5', label:'누유'},
        {code:'3', label:'고온'}, {code:'9', label:'점검'},
      ],
      eventTip: {'1':'', '2':'', '3':'', '4':'', '5':'', '6':'', '7':'', '8':'', '9':''},
      badgeColor: {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'},
      eventColor: {
        '1':'warning', // 넘침
        '2':'warning', // 부족
        '3':'danger',  // 화재
        '4':'info',    // 수분
        '5':'danger',  // 누유
        '6':'danger',  // 넘침2
        '7':'primary',  // 부족2
        '8':'light',   // 점검
        '9':'warning'  // 점검
      },
      eventCodeMap: this.$store.state.codeMaps['EVENT'],
    }
  },
  computed: {
    // 경보가 발생한 항목만. 경보 없는 항목은 badgeColor 가 기본값 'dark' 다
    activeItems(){
      return this.items.filter(it => this.badgeColor[it.code] && this.badgeColor[it.code] !== 'dark');
    },
  },
  created(){
    // console.log( '----------------WidgetEvents created ----------------');
  },
  mounted(){
  },
  methods: {
    setEvents(val) {
      const arr = val.data;
      // console.log( 'data', val );
      if(arr?.length===0){
        this.eventTip = {'1': '', '2': '', '3': '', '4': '', '5': '', '6': '', '7': '', '8': '', '9': ''};
        this.badgeColor = {'1':'dark', '2':'dark', '3':'dark', '4':'dark', '5':'dark', '6':'dark', '7':'dark', '8':'dark', '9':'dark'};
        return;
      }
      const dts = iosDtToLocal(val.dt);
      arr.map(e => {
        this.badgeColor[e.code] = this.eventColor[e.code];
        let message = e.text.replace(/\|/g, '<br/> ■');
        this.eventTip[e.code] = `<b>[${this.eventCodeMap[e.code]}] ${dts}</b> <br/> ■ ${message}`;
      })
    }
  }
}
</script>
